module.exports = __webpack_public_path__ + "static/media/1040215500.a36f6226.jpg";